import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-best-k12-digital-content-india',
  templateUrl: './best-k12-digital-content-india.component.html',
  styleUrls: ['./best-k12-digital-content-india.component.scss']
})
export class BestK12DigitalContentIndiaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Best K–12 Digital Content in India | VIRSA K–12 Content');
    this.metaService.updateTag({
      name: 'description',
      content: 'Explore VIRSA K–12 Digital Content with curriculum-aligned lessons, animated concept videos, assessments and worksheets for modern schools and smart classrooms.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'Best K–12 Digital Content in India, Best K–12 Content in India, Best Digital K–12 Content in India, K–12 Digital Content India, K–12 Content Provider India, K–12 Content Company India, Digital Learning Content for Schools, NCERT-Aligned Digital Content, Digital Content for Smart Classrooms, K–12 Animated Content, K–12 Learning Content, VIRSA K–12 Digital Content, VIRSA K–12 Content'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
